import { render, staticRenderFns } from "./CustomerBonusContentList.vue?vue&type=template&id=dd8248d0&scoped=true"
import script from "./CustomerBonusContentList.vue?vue&type=script&lang=js"
export * from "./CustomerBonusContentList.vue?vue&type=script&lang=js"
import style0 from "./CustomerBonusContentList.vue?vue&type=style&index=0&id=dd8248d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8248d0",
  null
  
)

export default component.exports